export default "/images/vendor/flag-icon-css/flags/4x3/pf.svg?296e94595f307817fc2bf28cc6a98618";